// Feature flags — set via Railway env vars (VITE_* prefix).
// Default: false (absent = feature off).

// Controls lock icons and "never stored on our servers" copy on sensitive fields.
// Flip to true in Railway when P13 Sensitive Data Export (Phase 1) ships.
export const SENSITIVE_DATA_UI_ENABLED =
  import.meta.env.VITE_SENSITIVE_DATA_UI_ENABLED === 'true';

/**
 * INTERVIEW-SHELL-FLAG-1 (s206) — whether the Planner Magic interview surface may mount at all.
 *
 * 🔴 DEFAULT OFF, and the `=== 'true'` comparison is what makes that structural rather than
 * intentional: an absent variable, an empty string, "1", "TRUE" and a misconfigured deploy all
 * evaluate false. A new environment cannot surface the shell by forgetting something.
 *
 * Why it exists: the intro screen still renders `[SPEC copy pending]` three times, and the product
 * is being shown to people while GTM is shaped. Set `VITE_INTERVIEW_SHELL_ENABLED=true` on staging
 * to keep building against it; leave it unset on production.
 *
 * This HIDES, it does not delete. `interview_position` and `interview_completed_at` keep their
 * stored values — a planner with a saved position simply lands on the normal dashboard.
 */
export const INTERVIEW_SHELL_ENABLED =
  import.meta.env.VITE_INTERVIEW_SHELL_ENABLED === 'true';
